import { render, staticRenderFns } from "./changePasswordDialog.vue?vue&type=template&id=2d72ce56"
import script from "./changePasswordDialog.vue?vue&type=script&lang=js"
export * from "./changePasswordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports